// extracted by mini-css-extract-plugin
export default {"container":"TO-z","modal":"UO-z","dimensions":"VO-z","brandName":"WO-z","productName":"XO-z","labelValue":"YO-z","recipientEmail":"ZO-z","recommendedFit":"_O-z","hiddenField":"aP-z"};